/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 桌面客户端下载引导弹窗
 */
import './index.scss'
import React, { useState, useCallback, useEffect, useRef } from 'react'
import { Modal } from 'antd'
import sensors from '../../../utils/sensors'
import desktopLib from '../../../utils/desktopLib'
import download_button from '../../../images/download-client/dialog-button.png'
import CONFIG from '../../../constants/config'
import { useAppSelector } from '../../../app/hooks'
import { CloseCircleOutlined } from '@ant-design/icons'
import {
  shouldShowClientPromo,
  clearClientPromoPending,
  LS_DOWNLOAD_CLIENT_DISMISSED,
  SS_HOLD_PROMO_UNTIL_ROUTE_CHANGE
} from '../../../utils/downloadClientPromo'

const DownloadClientDialog = () => {
  const groupID = useAppSelector((store) => store.group.groupId)
  const pathname = useAppSelector(
    (store: any) => store.router?.location?.pathname ?? ''
  )
  const prevPathnameRef = useRef(pathname)
  const [visible, setVisible] = useState(() => {
    if (desktopLib.isDesktop) return false
    return shouldShowClientPromo()
  })

  const syncVisible = useCallback(() => {
    if (desktopLib.isDesktop) {
      setVisible(false)
      return
    }
    const prev = prevPathnameRef.current
    if (prev !== pathname) {
      sessionStorage.removeItem(SS_HOLD_PROMO_UNTIL_ROUTE_CHANGE)
      prevPathnameRef.current = pathname
    }
    setVisible(shouldShowClientPromo())
  }, [pathname])

  useEffect(() => {
    syncVisible()
  }, [syncVisible])

  const close = useCallback(() => {
    setVisible(false)
    localStorage.setItem(LS_DOWNLOAD_CLIENT_DISMISSED, 'true')
    clearClientPromoPending()
  }, [])

  const download = useCallback(() => {
    sensors.track('web_click_pop_workgroup_guide_download_client', {
      clickItem: 'downloadNow',
      groupID: groupID
    })
    close()
    window.location.href = CONFIG.DESKTOP_DOWNLOAD_URL
  }, [close, groupID])

  return (
    <Modal
      open={visible}
      wrapClassName="DownloadClientDialog"
      width={458}
      styles={{ body: { width: '458px', height: '346px' } }}
      footer={null}
      closable={false}
      centered
      mask={{ closable: false }}
    >
      <img
        className="download-btn"
        src={download_button}
        alt=""
        onClick={download}
      />
      <CloseCircleOutlined
        className="close-btn"
        onClick={() => {
          sensors.track('web_click_pop_workgroup_guide_download_client', {
            clickItem: 'close',
            groupID: groupID
          })
          close()
        }}
      />
    </Modal>
  )
}

export default DownloadClientDialog
